import { render, staticRenderFns } from "./ScoreBreakdownPopup.vue?vue&type=template&id=c9b70ad0&scoped=true"
import script from "./ScoreBreakdownPopup.vue?vue&type=script&lang=js"
export * from "./ScoreBreakdownPopup.vue?vue&type=script&lang=js"
import style0 from "./ScoreBreakdownPopup.vue?vue&type=style&index=0&id=c9b70ad0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b70ad0",
  null
  
)

export default component.exports